/**
 * Gr8Boost ERP logo — vector wordmark with stylised "8" + lightning bolt accent.
 * Renders inline SVG so it inherits tenant brand colour via the `accent` prop.
 *
 * Props:
 *   size      — height in px (default 28)
 *   accent    — hex of the bolt + dot (default Gr8Boost orange #FF4F00)
 *   dark      — text colour (default #0A0A0A); pass "#FFFFFF" for inverted bg
 *   showWord  — render the "Gr8Boost ERP" wordmark (default true)
 *   compact   — true → only the icon ("8" + bolt), no wordmark
 */
export default function Logo({ size = 28, accent = "#FF4F00", dark = "#0A0A0A", showWord = true, compact = false }) {
  const h = size;
  const iconW = h; // icon is square
  const wordmarkW = h * 5.2;
  return (
    <span className="inline-flex items-center gap-2 select-none" data-testid="gr8boost-logo" style={{ height: h }}>
      <svg width={iconW} height={h} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="Gr8Boost ERP">
        {/* dark rounded square */}
        <rect x="2" y="2" width="60" height="60" rx="14" fill={dark} />
        {/* the stylised 8 — two stacked rounded rings */}
        <g stroke="#FFFFFF" strokeWidth="4" fill="none">
          <circle cx="26" cy="22" r="9" />
          <circle cx="26" cy="42" r="11" />
        </g>
        {/* lightning bolt cutting through the 8 → motion / boost */}
        <path d="M44 12 L30 32 L40 32 L26 56 L40 36 L30 36 Z" fill={accent} stroke={accent} strokeWidth="1" strokeLinejoin="round" />
        {/* accent dot */}
        <circle cx="52" cy="14" r="3" fill={accent} />
      </svg>
      {showWord && !compact && (
        <span className="font-heading font-bold tracking-tight leading-none" style={{ color: dark, fontSize: h * 0.6 }}>
          Gr8<span style={{ color: accent }}>Boost</span><span className="text-[#495057] font-medium ml-1.5" style={{ fontSize: h * 0.42 }}>ERP</span>
        </span>
      )}
    </span>
  );
}
